<template>
  <div class="mx-2">
    <v-hover v-slot="{ hover }">
      <v-btn
        :outlined="!hover"
        color="nitro"
        class="font-weight-bold"
        :class="hover ? 'text-white' : ''"
        @click="showModal = true"
      >
        Selecione a sua língua estrangeira
        <v-icon class="ml-1">
          fa-solid fa-arrow-right-arrow-left
        </v-icon>
      </v-btn>
    </v-hover>

    <v-dialog
      v-model="showModal"
      :overlay-opacity="DEFAULT_MODAL_OPACITY"
      :width="modalWidth"
    >
      <v-card>
        <div class="px-4 py-3 d-flex justify-content-between border-bottom">
          <ModalTitle text="Selecione a sua língua estrangeira" />
          <BtnClose @click="showModal = false" />
        </div>

        <div class="px-4">
          <v-radio-group v-model="subject_id">
            <v-radio
              v-for="l in languages"
              :key="l.name"
              :label="l.name"
              :value="l.value"
            />
          </v-radio-group>
          <div class="d-flex justify-content-center">
            <v-btn
              color="nitro"
              class="mb-3 text-center text-white"
              @click="changeLanguage"
            >
              Salvar
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { selectModulesRouteName } from '../constants/routes'
import ModalTitle from "@/common/components/ModalTitle";
import BtnClose from "@/common/components/BtnClose";
import {DEFAULT_MODAL_OPACITY} from "@/student/constants/general"
export default {
    components:{ ModalTitle, BtnClose },
    data() {
        return {
          DEFAULT_MODAL_OPACITY,
          showModal: false,
          modalWidth: '320px',
          languages:[
            {
              name: 'Inglês',
              value: 5
            },
            {
              name: 'Espanhol',
              value: 4
            },
            {
              name: 'Ambas',
              value: 0
            }
          ],
        }
    },
    computed:{
        subject_id:{
          get(){
            return this.$store.state.auth.user.language_subject_id ?? 0
          },
          set(value){
            return this.$store.state.auth.user.language_subject_id = value
          }
        }
    },
    methods:{
        ...mapActions(['getSelectionModules']),
        async changeLanguage(){
            await axios.post(`/api/v1/student/language/change`, {
              subject_id: this.subject_id ? this.subject_id : null,
            }).then(()=> {
              this.showModal = false;
              this.$notify({
                type: 'success',
                text: 'Preferência de idioma alterada.'
              });
              if(this.$route.name === selectModulesRouteName){
                this.getSelectionModules();
              }
            })
        },
    }

}
</script>
<style lang="scss" scoped>
.custom-filter-select {
  max-width: 220px;

  & > :first-child > :first-child {
    margin: 0 !important;
  }

  & > :first-child > :last-child {
    display: none !important;
  }
}
</style>
